import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Globe = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Globe' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2,8 C2,8 5.5,9 7,10 C8.5,11 7.56437103,12.4191614 8,13 C8.43562897,13.5808386 10,12 10,15 C10,18 13,16 13,19 C13,22 15.5,21.5 16,20 C16.5,18.5 18.2333023,16.8664183 18,15 C17.7666977,13.1335817 17,12 15,12 C13,12 11.5,11.5 11,10 C10.5,8.5 14,8 13,5 C12,2 13,1 13,1 M23,12 C23,18.075 18.075,23 12,23 C5.925,23 1,18.075 1,12 C1,5.925 5.925,1 12,1 C18.075,1 23,5.925 23,12 L23,12 Z' />
  </StyledIcon>
);
